import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface PageHeroProps {
  crumbs: Crumb[];
  eyebrow?: string;
  title: string;
  desc?: string;
}

export default function PageHero({ crumbs, eyebrow, title, desc }: PageHeroProps) {
  return (
    <section className="w-full border-b border-background-300/60 bg-background-100">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <nav aria-label="面包屑导航">
          <ol className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
            {crumbs.map((crumb, index) => (
              <li key={crumb.label} className="flex items-center gap-2">
                {index > 0 && (
                  <span className="w-3.5 h-3.5 flex items-center justify-center text-foreground-400">
                    <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
                  </span>
                )}
                {crumb.to ? (
                  <Link to={crumb.to} className="hover:text-primary-600 transition-colors cursor-pointer">
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="text-foreground-700">{crumb.label}</span>
                )}
              </li>
            ))}
          </ol>
        </nav>

        <div className="mt-5 max-w-3xl">
          {eyebrow && (
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] uppercase text-primary-600">
              <span className="w-6 h-px bg-primary-400" />
              {eyebrow}
            </span>
          )}
          <h1 className="mt-3 font-heading text-2xl md:text-4xl font-bold tracking-tight text-foreground-950">
            {title}
          </h1>
          {desc && <p className="mt-4 text-sm md:text-base leading-7 text-foreground-600">{desc}</p>}
        </div>
      </div>
    </section>
  );
}